import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import { read, utils, writeFile } from 'xlsx';
import PublishIcon from '@material-ui/icons/Publish';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import DatePicker from '@material-ui/lab/DatePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  FormControl,
  TextField,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const UpdateTariffs = () => {
  const m = moment();
  const [tariffs, setTariffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [begDate, setBegDate] = useState(m.subtract(30, 'd'));
  const [endDate, setEndDate] = useState(new Date());
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const classes = useStyles();

  const handleImport = ($event) => {
    const { files } = $event.target;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          setTariffs(rows);
        }
      };
      console.log('tarifs generated', tariffs);
      reader.readAsArrayBuffer(file);
    }
  };

  const updateTariffCosts = () => {
    console.log('b4 tarifs generated', tariffs);
    const jsonData = {
      StartDate: '2023-01-31',
      tariffs
    };
    console.log('after jsondata', jsonData);
    console.log('after jsondata strifngif', JSON.stringify(jsonData[0]));
  };

  const updateTariffCost = async () => {
    setLoading(true);
    const jsonData = {
      tariffs,
      begDate: '2023-01-31'
    };
    const startdate = '2023-01-31';
    const jsonClient = [];
    jsonClient.push(tariffs);
    console.log('update tarifs stringified now', JSON.stringify(jsonClient[0]));
    fetch(
      `${baseUrl}/api/setting/UpdateTariffCost?begDate=${moment(begDate).format(
        'YYYY-MM-DD'
      )}&endDate=${moment(endDate).format('YYYY-MM-DD')}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonClient[0])
      }
    )
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned tariff', res);
          setLoading(false);
          notifyPopup(`Tariffs Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Updating Tariffs!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Card>
      <CardContent>
        <Box>
          <div className="col-sm-6 offset-3">
            <div className="row">
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Grid container spacing={2}>
                <Grid item xs={5} sm={3}>
                  <Typography component="span" variant="h4" gutterBottom>
                    Update Tariffs
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Start Date"
                      inputFormat="dd/MM/yyyy"
                      value={begDate}
                      onChange={(e) => {
                        setBegDate(e);
                      }}
                      renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="End Date"
                      inputFormat="dd/MM/yyyy"
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e);
                      }}
                      renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={3} ml={2}>
                  <div className="col-md-6">
                    <div className="input-group">
                      <div className="custom-file">
                        <input
                          type="file"
                          name="file"
                          className="custom-file-input"
                          id="inputGroupFile"
                          required
                          onChange={handleImport}
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={1} ml={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    startIcon={<PublishIcon />}
                    onClick={() => updateTariffCost()}
                  >
                    Process
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </Box>

        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Tariff</TableCell>
                <TableCell align="right">Cost</TableCell>
                {/* <TableCell align="right">StartDate</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {tariffs.map((row) => (
                <TableRow key={row.Tariff}>
                  <TableCell component="th" scope="row">
                    {row.Tariff}
                  </TableCell>

                  <TableCell align="right">{row.Cost}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </CardContent>
    </Card>
  );
};

export default UpdateTariffs;
